module.exports = __webpack_public_path__ + "img/amex.e64c221d.svg";